import { compose } from "redux";
import { connect } from "react-redux";
import React, { PureComponent } from "react";

import {
  employeeWorkScheduleFormOnChange,
  createEmployeeWorkScheduleOnSubmit,
} from "features/planner/employee/employee.actions";

import {
  WORK_SCHEDULE_FORM,
  SIMPLE_EDIT_WORK_SCHEDULE_MODAL_ID,
} from "features/planner/employee/employee.constants";

import SimpleFormModal from "app/components/SimpleFormModal";
import SimpleWorkScheduleForm from "features/planner/employee/schedule/components/SimpleWorkScheduleForm";

class SimpleWorkScheduleModal extends PureComponent {
  render() {
    const { dispatchCreateEmployeeWorkScheduleOnSubmit } = this.props;

    return (
      <SimpleFormModal
        Icon={null}
        submitText="Save"
        title="Adjust Work Schedule"
        component={SimpleWorkScheduleForm}
        modalId={SIMPLE_EDIT_WORK_SCHEDULE_MODAL_ID}
        onSubmit={dispatchCreateEmployeeWorkScheduleOnSubmit}
        form={{
          form: WORK_SCHEDULE_FORM.ID,
        }}
      />
    );
  }
}

export default compose(
  connect(
    null,
    {
      dispatchEmployeeWorkScheduleFormOnChange: employeeWorkScheduleFormOnChange,
      dispatchCreateEmployeeWorkScheduleOnSubmit: createEmployeeWorkScheduleOnSubmit,
    },
  ),
)(SimpleWorkScheduleModal);
